// Copyright (c) 2022 by Move Closer

import { ModulesFormRegistryEntry } from '../../../contexts'

import { footerFactory } from '../Footer.factory'
import { FooterModuleVersion } from '../Footer.config'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl> (edited)
 */
export const footerModuleEntry: ModulesFormRegistryEntry = {
  component: () => import(
    /* webpackChunkName: "form/core" */ './Footer.form.vue'
  ),
  factory: footerFactory,
  icon: require('../footer.svg'),
  label: 'modulesForms.Footer._name',
  versions: {
    [FooterModuleVersion.Default]: 'modulesForms.Footer.versions.default',
    [FooterModuleVersion.Simple]: 'modulesForms.Footer.versions.simple'
  },
  restrictions: {
    allowedTypes: ['layout']
  }
}
